module.exports = __webpack_public_path__ + "static/10-63f4dc4dc4aa2bc0480edeb232e77c7b.png";